<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'InputTip',
  props: {
    message: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
</script>

<template>
  <VaPopover :message="t(message)" :data-lang="message" placement="top" class="ml-2 tip">
    <VaIcon aria-hidden="true" name="help_outline" />
  </VaPopover>
</template>
